import {
    TOGGLE_LOADING, 
    UNAUTHORIZED_CONVERSATION,  
    FETCH_CONVERSATION_LIST,
    FETCH_CONVERSATION_DATA,
    FETCH_MESSAGE_LIST,
    } from "../../constants/ConversationActionTypes";
  
  
    const initialState = {
      loading: false,
      unAuthorisedConversation:null,
      conversationListing:null,
      conversationData:null,
      messageListing:null,
    }
  
    const conversationReducer = (state = initialState, { type, payload }) => {
      switch (type) {
        case TOGGLE_LOADING:
          return { ...state, loading: payload };
        case UNAUTHORIZED_CONVERSATION:
        return { ...state, unAuthorisedConversation: payload };
        case FETCH_CONVERSATION_LIST:
        return { ...state, conversationListing: payload};
        case FETCH_CONVERSATION_DATA:
        return { ...state, conversationData: payload };
        case FETCH_MESSAGE_LIST:
        return { ...state, messageListing: payload };
        default:
          return state;
      }
    };
  
    export default conversationReducer;
  